import {HeaderHero} from "base/layout";
import {LogoLink} from "base/component/presentational";

export const MainHeaderHero = () => {
    const leftLogos = [
        <LogoLink
            key="remap"
            href="/"
            title="Home"
            src="/images/logos/logo_remap.png"
            targetBlank={false}
            logoHeight={40}
        />,
    ];

    return <HeaderHero left={leftLogos} />;
};
